<template>
    <div>
        <label style="font-size:14px;margin-left:18px;" v-if="top">{{top}}</label>
        <div style="display:flex;width:100%;margin:auto;flex-wrap: wrap;align-items: center">
            <label
                    style="font-size:14px;margin-top:19px;"
                    v-if="lable"
            >
                <font color="red" style="margin-right:-2px;" v-if="edit">*</font>
                <font color="red" style="margin-right:8px;" v-else></font>
                {{lable}}
            </label>
            <div v-for="(image,index) in imageList" :key="index" style="height:62px;">
                <Icon
                        v-if="edit"
                        class="image-icon"
                        color="red"
                        @click="imgDel"
                        :value="image"
                        :key="image"
                        name="clear"
                        size="25px"
                />
                <img
                        v-if="image==null||undefined"
                        src="../assets/img/defaulted.png"
                        style="margin-left:10px;width: 55px;height: 55px;"
                />
                <img
                        v-else
                        class="image"
                        @click="previeImage"
                        :src=" downloadImg+image"
                        style="width: 55px;height: 55px;"
                />
            </div>
            <img
                    style="width: 55px;height: 55px;margin-left:10px;margin-top:5px;"
                    src="../assets/uploadImage.jpg"
                    v-if="edit&&count>imageList.length"
                    @click="chooseImg"
            />
        </div>
    </div>
</template>

<script>
    import wx from "weixin-js-sdk";
    import {Icon, ImagePreview} from "vant";
    import http from "@/http";
    import {downloadImg} from "@/config"

    export default {
        components: {Icon, ImagePreview},
        props: {
            count: {type: Number, default: 9},
            imageList: {type: Array, required: true},
            lable: {type: String, required: false},
            type: {type: String, required: false},
            top: {type: String, required: false},
            edit: {type: Boolean, default: false},
            sourceType: {type: Array, default: () => ["album", "camera"]},
        },
        mounted() {
        },
        data() {
            return {downloadImg}
        },

        computed: {},
        methods: {
            chooseImg(e) {
                // this.imageList.push("123123");
                // return;

                const This = this;
                const count = This.count - This.imageList.length;
                wx.chooseImage({
                    count: count > 9 ? 9 : count, // 默认9  苹果不允许超过9张
                    sizeType: ["original", "compressed"],
                    sourceType: This.sourceType,
                    success: function (res) {
                        const localIds = res.localIds;
                        This.getImage(localIds);
                    }
                });
            },
            getImage(localIds) {
                console.log(localIds);
                let localId = localIds.pop();
                const This = this;

                if (!localId) return;
                wx.getLocalImgData({
                    localId: localId,
                    success(res) {
                        This.uploadImages(res.localData);

                        This.getImage(localIds);
                    },
                    fail(res) {
                        alert("网络开小差了，请重新选择图片");
                    }
                });
            },
            uploadImages(imageBase64) {
                imageBase64 = imageBase64.replace(/[\r\n]/g, ""); //解决微信api返回的数据有换行
                // 解决ios和Android的差异
                if (window.__wxjs_is_wkwebview) {
                    imageBase64 = imageBase64.slice(imageBase64.indexOf(",") + 1);
                }
                const This = this;
                http.tokiot.other.uploadImageBase64({
                    base64: imageBase64,
                    type: this.type,
                    suffix: ".jpg"
                })
                    .then(ret => {
                        if (ret) {
                            This.imageList.push(ret);
                            This.$emit("imageChange", This.imageList);
                        } else {
                            alert("网络开小差了，请重新选择图片");
                        }
                    })
            },
            imgDel(e) {
                let list = [];
                this.imageList.forEach(image => {
                    if (image !== e.target.getAttribute("value")) {
                        list.push(image);
                    }
                });
                this.$emit("imageChange", list);
            },
            previeImage(e) {
                e.stopPropagation()
                const list = [e.target.src];
                ImagePreview({images: list, loop: false, showIndex: false});
            }
        }
    };
</script>


<style lang="less" scoped>
    .image {
        float: left;
        margin-left: 8px;
        margin-top: 5px;
    }

    .image-icon {
        position: absolute;
        margin-left: 42px;
        margin-top: 0px;
        z-index: 2;
        opacity: 0.7;
    }
</style>
